// Singleton formatter to prevent recreation on every function call
const rtf = new Intl.RelativeTimeFormat('en', { numeric: "auto" });

// Array representing one minute, hour, day, week, month, etc in seconds
const cutoffs = [60, 3600, 86400, 86400 * 7, 86400 * 30, 86400 * 365, Infinity];

// Array equivalent to the above but in the string representation of the units
const units: Intl.RelativeTimeFormatUnit[] = ["second", "minute", "hour", "day", "week", "month", "year"];

/**
 * Utility function to get relative time string (e.g., "2 hours ago", "yesterday")
 * Optimized to reuse Intl.RelativeTimeFormat instance.
 */
export function getRelativeTimeString(date: Date | string): string {
  const timeMs = typeof date === "string" ? new Date(date).getTime() : date.getTime();
  const deltaSeconds = Math.round((timeMs - Date.now()) / 1000);
  
  // Grab the ideal cutoff unit
  const unitIndex = cutoffs.findIndex(cutoff => cutoff > Math.abs(deltaSeconds));
  
  // Get the divisor to divide from the seconds
  const divisor = unitIndex ? cutoffs[unitIndex - 1] : 1;
  
  return rtf.format(Math.floor(deltaSeconds / divisor), units[unitIndex]);
} 